import { track } from "@/features/analytics";
import { environment } from "@environment";
import { usePurchaseSubscriptionStore } from "../store/purchase-subscription.store";

declare global {
  interface Window {
    Paddle: any;
  }
}

const PADDLE_SRC = "https://cdn.paddle.com/paddle/paddle.js";

let paddle: Promise<any> | null = null;

const setupPaddle = (Paddle: any) => {
  if (environment.env !== "production") {
    Paddle.Environment.set("sandbox");
  }
  Paddle.Setup({
    vendor: environment.paddle.vendorId,
    eventCallback: (data: any) => {
      usePurchaseSubscriptionStore.getState().setCheckoutDetails(data);
      if (data.event === "Checkout.PaymentMethodSelected") {
        track("click change payment method", {
          "payment method": data.eventData.payment_method,
        });
      } else if (data.event === "Checkout.Error") {
        track("failed paying customer", {
          "failure message": data.eventData.error,
        });
      } else if (data.event === "Checkout.PaymentComplete") {
        track("success payment transaction");
      }
    },
  });
};

/**
 * Paddle, loaded and set up the first time checkout needs it. It used to be a
 * render-blocking script on every page plus an app-wide setup, which cost
 * about 0.75 s of main-thread time on every editor load (CEO review), while
 * only the purchase dialog uses it. A failed load is retried next time.
 */
export const loadPaddle = (): Promise<any> => {
  paddle ??= new Promise((resolve, reject) => {
    if (window.Paddle) {
      setupPaddle(window.Paddle);
      resolve(window.Paddle);
      return;
    }
    const script = document.createElement("script");
    script.src = PADDLE_SRC;
    script.async = true;
    script.onload = () => {
      setupPaddle(window.Paddle);
      resolve(window.Paddle);
    };
    script.onerror = () => {
      paddle = null;
      script.remove();
      reject(new Error("Paddle failed to load"));
    };
    document.head.appendChild(script);
  });
  return paddle;
};
